import { ID } from "common/entities/IEntity";
import { filterParams } from "core/util/ParamUtil";
import { Entity, Field } from "typegraph";
import { Topic } from "./Topic";


export interface IOrganizationFlaggedTopicParams {
	guid: string;
	sort?: string;
	pageSize?: number;
	pageNumber?: number;
	flagged?: boolean;
}

@Entity({one: "organization", params: filterParams<IOrganizationFlaggedTopicParams>(['guid'])})
export class Organization {

	@Field()
	public id: ID;

	@Field()
	public name: string;

	@Field({entity: Topic, params: filterParams<IOrganizationFlaggedTopicParams>(['sort', 'pageSize'], {flagged: true})})
	public discussionList?: Topic[];

}



// WEBPACK FOOTER //
// ./src/panels/organizationAdmin/entities/OrganizationFlaggedTopics.ts